module.exports = __webpack_public_path__ + "static/media/sass.3023657d.svg";